module.exports = __webpack_public_path__ + "assets/30aa1241b44c2cbc6b033cd53a452ac1.png";